"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";

export type TabKey = "global" | "misc";

interface ActiveTabContextProps {
  activeTab: TabKey;
  handleTabChange: (tab: TabKey) => void;
}

const ActiveTabContext = createContext<ActiveTabContextProps | undefined>(
  undefined,
);

export const ActiveTabProvider = ({ children }: { children: ReactNode }) => {
  const [activeTab, setActiveTab] = useState<TabKey>("global");

  const handleTabChange = (tab: TabKey) => {
    setActiveTab(tab);
  };

  return (
    <ActiveTabContext.Provider value={{ activeTab, handleTabChange }}>
      {children}
    </ActiveTabContext.Provider>
  );
};

export function useActiveTab() {
  const context = useContext(ActiveTabContext);
  if (!context) {
    throw new Error("useActiveTab must be used within an ActiveTabProvider");
  }
  return context;
}
